import React, { useCallback, useEffect, useState } from 'react'
import styles from '../Student/login.module.css'
import { useNavigate } from 'react-router-dom'
import { useFormik } from "formik"
import * as yup from "yup";
import { Checkbox, CircularProgress } from '@mui/material';
import { ArrowIcon, GoogleIcon, HidePasswordIcon, LogoIcon, PasswordVisible } from '../../../svg';
import { useDispatch } from 'react-redux'
import { loginAffiliateWithGoogle, affiliateLogin } from '../../redux/affiliateLoginSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import {
    signInWithPopup,
    GoogleAuthProvider,
} from "firebase/auth";
import { useSelector } from 'react-redux';
import { auth } from '../../helper/firebase';
import { AffiliategetProfile } from '../../redux/affiliateSlice';
import PendingModal from '../../../component/PendingModal';
import ReCAPTCHA from "react-google-recaptcha";
import Toastify from '../../helper/Toastify';


const AffiliateLogin = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [error, setError] = useState(null);
    const [googleErrorMessage, setGoogleErrorMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [captchaValue, setCaptchaValue] = useState(null);




    const userProfile = useSelector((state) => state.affiliate);
    const getUserProfile = userProfile?.affiliate;

    useEffect(() => {
        dispatch(AffiliategetProfile())
    }, [dispatch])

    useEffect(() => {
        if (getUserProfile?.status === "PENDING") {
            setShowModal(true)
        }
        else {
            setShowModal(false)
        }

    }, [dispatch, getUserProfile])
    // schema -----------
    const schema = yup.object().shape({
        email: yup.string().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Please enter valid email").required("Please enter valid email"),
        password: yup.string().required("Password is required")
    })

    const {
        errors, values, handleChange, touched, setFieldValue, handleBlur, resetForm, handleSubmit,
    } = useFormik({
        initialValues: {
            email: "",
            password: ""
        },
        validationSchema: schema,
        onSubmit: (values) => {

            if (!captchaValue) {
                Toastify.error("Please verify the reCAPTCHA")
                return;
            }

            handleLogin(values);

        }
    })


    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    const handleLogin = useCallback(async (values) => {
        setLoading(true);
        try {
            const result = await dispatch(affiliateLogin(values));
            unwrapResult(result)
            navigate('/affiliate/affiliateDashboard');
            // navigate("")
        } catch (error) {
            console.error('Login failed:', error);
        } finally {
            setLoading(false);
        }
    }, [dispatch, navigate]);

    const handleGoogleSignUp = async (e) => {
        e.preventDefault();

        // Instantiate a GoogleAuthProvider object
        const provider = new GoogleAuthProvider();

        try {
            // Sign in with a pop-up window
            const result = await signInWithPopup(auth, provider);

            // Pull signed-in user credential.
            const user = result.user;

            console.log("sasaas", result)

            const resultAction = await dispatch(loginAffiliateWithGoogle({
                email: user.email,
                googleIdToken: user.accessToken
            }));

            unwrapResult(resultAction);

            navigate("/affiliate/affiliateDashboard");

        } catch (err) {
            // Handle errors here.
            const errorMessage = err.message;
            const errorCode = err.code;

            setError(true);

            switch (errorCode) {
                case "auth/operation-not-allowed":
                    setGoogleErrorMessage("Email/password accounts are not enabled.");
                    break;
                case "auth/operation-not-supported-in-this-environment":
                    setGoogleErrorMessage("HTTP protocol is not supported. Please use HTTPS.")
                    break;
                case "auth/popup-blocked":
                    setGoogleErrorMessage("Popup has been blocked by the browser. Please allow popups for this website.")
                    break;
                case "auth/popup-closed-by-user":
                    setGoogleErrorMessage("Popup has been closed by the user before finalizing the operation. Please try again.")
                    break;
                default:
                    setGoogleErrorMessage(errorMessage);
                    break;
            }
        }
    };


    return (
        <div className={styles.main}>
            <div className={styles.mainContainer}>
                <div style={{ cursor: "pointer" }} onClick={() => navigate("/affiliate/affiliate")}>
                    <LogoIcon />
                </div>
            </div>
            <div className={styles.login}>
                <div className={styles.mobileViewLogin}>
                    <div className={styles.mobileLogoStyle}>
                        <h3>KINGSTER</h3>
                    </div>
                </div>
                <div className={styles.content} style={{ marginTop: 30 }}>
                    <h3>Sign in to your account</h3>
                    {/* <p>Please login to continue to your account.</p> */}
                    <div style={{ marginTop: 40 }}>
                        <label className={styles.label}>Email</label>
                        <div className={styles.inputbox}>
                            <input
                                type='email'
                                onBlur={handleBlur}
                                value={values.name}
                                placeholder='Email Address'
                                name="email"
                                onChange={handleChange}
                            />
                        </div>
                        {
                            errors.email && touched.email && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.email}</p>
                        }
                    </div>

                    <div style={{ marginTop: 20 }}>
                        <label className={styles.label}>Password</label>
                        <div className={styles.inputbox}>
                            <input
                                type={showNewPassword ? 'text' : 'password'}
                                onBlur={handleBlur}
                                value={values.password}
                                placeholder='Password'
                                name="password"
                                onChange={handleChange}
                            />
                            <div onClick={() => setShowNewPassword(!showNewPassword)} style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                                {showNewPassword ? <PasswordVisible /> : <HidePasswordIcon />}
                            </div>
                        </div>
                        {
                            errors.password && touched.password && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.password}</p>
                        }

                    </div>

                    <div
                        className={styles.forgotText}
                        onClick={() => navigate('/affiliate/forgotPassword')}
                    >Forgot Password?</div>


                    <div className={styles.checkStyle} style={{ marginTop: 20 }}>
                        <div style={{ transform: "scale(0.6)", transformOrigin: "0 0", position: "relative", top: -2 }}>
                            <ReCAPTCHA
                                sitekey="6Lc8vBcrAAAAANcniDVhDJlYjI_dim7gFk3L4u19"
                                onChange={handleCaptchaChange}
                                style={{ height: "40px" }}
                            />
                        </div>
                        {/* <div style={{ marginLeft: -10, }}>
                            <div className={styles.checkbox}>
                                <Checkbox /><span className={styles.agreetext}>Remember me</span>
                            </div>
                        </div> */}
                        <div
                            className={styles.saveButtonStyle}
                            onClick={handleSubmit}
                            disabled={loading}
                        // style={{width:'50%'}}
                        >
                            {
                                loading ?
                                    <CircularProgress size={25} thickness={4.5} sx={{ color: "#fff" }} />
                                    : "Sign In"
                            } <ArrowIcon />
                        </div>
                    </div>

                    <div style={{ marginTop: 20 }}>
                        <div onClick={handleGoogleSignUp}>
                            <div className={styles.signWith} style={{ marginTop: 20 }}>
                                <div className={styles.lineStyle} />
                                <div className={styles.orText}>
                                    SIGN IN WITH
                                </div>
                                <div className={styles.lineStyle} />
                            </div>
                            <div className={styles.google}>
                                <div className={styles.googleStyle}>
                                    <GoogleIcon /> <div className={styles.singleLine} />Google
                                </div>
                            </div>
                        </div>
                        <div className={styles.textStyle} onClick={() => navigate('/affiliate/registration')}>
                            New at Kingster? <span className={styles.loginText}>Register here </span>
                        </div>
                    </div>

                </div>
            </div>
            <PendingModal
                open={showModal} />
        </div>
    )
}



export default AffiliateLogin;
